import setFullbanner from './home/1_fullbanner';
import setIconsHorizontal from './home/horizontal_icons_slider.js';
import setProductSlider from './home/3_product_slider';
import setInstagramSection from './home/instagram_section';
import ShopLook from './home/shop_the_look';
import setCarousel from '../components/carousel';

//addImports

import setTopBar from '../components/topBar';
import handleConditionalLazy from '../components/conditionalLazy';

const Home = {
  init: function () {
    setTopBar();
    handleConditionalLazy();

    setFullbanner()
		setIconsHorizontal();
		setProductSlider()
		setInstagramSection();
		ShopLook.init()
		setCarousel();
		
		//calls
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init();
});
